import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { CookieUtil } from '@utils/cookies';

@Injectable({
  providedIn: 'root'
})
export class GetUserMeService {

  private domain:any;
  private endpoint:string = 'users/get-user';
  private api_key:any;

  constructor(
    private http:HttpClient,
    private cookies: CookieUtil,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.domain = `${environment.API_BASE_URL}`;
    this.api_key = environment.API_KEY;
  }

  GET_USER_ME(idToken: any): Promise<any>{
    if(isPlatformBrowser(this.platformId)){
      return this.http.get(this.domain + this.endpoint,  
        {
          observe: 'response',
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'x-api-key': `users-${this.api_key}`,
            'Authorization': `Bearer ${idToken}`
          }) 
        }).toPromise()
        .then((response:any) => {
          return this.extractData(response);
        })
        .catch(this.extractData);
    }
    return Promise.reject('Server Side Rendering');
  }

  private extractData(res: any) {
    let body = res;
    return body;
  }
}
